@if (isLoading) {
<div class="loading-wrapper">
  <mat-spinner diameter="90"></mat-spinner>
  <h3>Cargando...</h3>
</div>
} @else {
<div mat-dialog-title>
  <h2>{{ type === 'vacation' ? 'Conductores de Vacaciones' : 'Conductores Indisponibles' }} - Semana {{ weekData?.week_number }}</h2>
</div>

<mat-dialog-content>
  @if (weekData) {
  <div class="week-info">
    <div class="info-row">
      <strong>Semana:</strong>
      <span>{{ weekData.week_number }}</span>
    </div>
    <div class="info-row">
      <strong>Fechas:</strong>
      <span>{{ formatDate(weekData.start_date) }} - {{ formatDate(weekData.end_date) }}</span>
    </div>
  </div>

  @if (type === 'vacation') {
  <!-- Only show vacation drivers -->
  <div class="drivers-section">
    <h3>Conductores de Vacaciones ({{ vacationDrivers.length }})</h3>

    @if (vacationDrivers && vacationDrivers.length > 0) {
    <div class="drivers-list">
      @for (driver of vacationDrivers; track driver.idHolidays) {
      <div class="driver-card">
        <div class="driver-header">
          <div class="driver-info">
            <!-- <mat-icon>person</mat-icon> -->
            <div>
              <div class="driver-name">{{ driver.name }}</div>
              <div class="driver-id">ID: {{ driver.personnelNumber }}</div>
              <span class="type-badge" [ngClass]="getTypeBadgeClass(driver._type)">
                {{ getTypeLabel(driver._type) }}
              </span>
            </div>
          </div>
        </div>
        <div class="driver-dates">
          <mat-icon>event</mat-icon>
          <span>{{ formatDate(driver.initDate) }} - {{ formatDate(driver.endDate) }}</span>
        </div>
      </div>
      }
    </div>
    } @else {
    <p class="no-data">No hay conductores de vacaciones en esta semana.</p>
    }
  </div>
  } @else {
  <!-- Only show unavailable drivers -->
  <div class="drivers-section">
    <h3>Doble tripulación ({{ doble_tripulacio }})</h3>
    <h3>Conductores Indisponibles ({{ unavailableDrivers.length }})</h3>

    @if (unavailableDrivers && unavailableDrivers.length > 0) {
    <div class="drivers-list">
      @for (driver of unavailableDrivers; track driver.idHolidays) {
      <div class="driver-card">
        <div class="driver-header">
          <div class="driver-info">
            <!-- <mat-icon>person_off</mat-icon> -->
            <div>
              <div class="driver-name">{{ driver.name }}</div>
              <div class="driver-id">ID: {{ driver.personnelNumber }}</div>
              <span class="type-badge" [ngClass]="getTypeBadgeClass(driver._type)">
                {{ getTypeLabel(driver._type) }}
              </span>
            </div>
          </div>
        </div>
        <div class="driver-dates">
          <mat-icon>event</mat-icon>
          <span>{{ formatDate(driver.initDate) }} - {{ formatDate(driver.endDate) }}</span>
        </div>
      </div>
      }
    </div>
    } @else {
    <p class="no-data">No hay conductores indisponibles en esta semana.</p>
    }
  </div>
  }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button class="cancel" (click)="close()">Cerrar</button>
</mat-dialog-actions>
}